'use client'

import { TitleWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import { css } from '@lastbrand/web-ui-styled-system/css'

import { CollectionTitleDS } from '@src/components/blocks/collection-title-ds'
import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { SectionContentContainer } from '@src/ds/blocks/section-content-container'
import { GetSeoMetapageDataProps } from '@src/quince-site-common/src/utils/seo/getSeoMetadata'

import { usePLPageMeta } from '../../pl-page-context'

const spacingClass = css({
  mb: { base: 'space-20', lg: 'space-24' },
  "div[data-widget-type='TITLE']:has(+ div[data-widget-type='PRODUCT_COUNT']) &": {
    mb: { base: 'space-8', lg: 'space-24' },
  },
})

export function CollectionTitleDSWidget(props: PLTypedWidgetProps<TitleWidgetData>) {
  const pageMeta = usePLPageMeta()

  // Prefer the title carried by the TITLE widget payload (PL may return a
  // subcollection-specific title here), and fall back to the page-level meta
  // title when the widget does not provide one.
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty strings from proto3 defaults should also fall back to pageMeta.title
  const resolvedTitle = props.data.titleData?.text || pageMeta.title || ''

  return (
    <SectionContentContainer data-testid="collection-title-widget" className={spacingClass}>
      <CollectionTitleDS
        title={resolvedTitle}
        hideCollectionPageTitle={false}
        isRootCollectionPage={false}
        isJumpLink={false}
        // Do not forward widgetData.text as subCollectionTitle: in PL this string equals
        // meta.title (the H1/display title), so passing it triggers CollectionTitle's
        // dynamic SeoPageRouter (gated by `subCollectionTitle && experiment active`) on
        // the second render and overrides the <title> with meta.title instead of the
        // SEO title from meta.seoData.title. Dynamic subcollection-title-on-filter for
        // PL is tracked separately and intentionally deferred.
        subCollectionTitle={undefined}
        seoData={pageMeta.seoData as GetSeoMetapageDataProps | null}
        alternateUrls={{}}
        offerMessage={undefined}
      />
    </SectionContentContainer>
  )
}
